import BaseApi from './base/BaseApi';

export default class TaskChangeApi extends BaseApi {
  static entityName = 'task_changes';
}
